var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('iframe',{ref:"myIframe",staticStyle:{"width":"100%","height":"100%"},attrs:{"scrolling":"no","frameborder":"0","src":"/html/linianwenhua.html"}})])}
var staticRenderFns = []

export { render, staticRenderFns }